/**
 * L'ordre dans lequel Échap ferme ce qui est ouvert, écrit à un seul endroit (chantier
 * `nettoyage-fiche`, ticket 02). Il reprend, cas par cas, ce que faisaient avant lui les
 * écoutes posées une à une sur la fenêtre (relevé de `scripts/verification/echap.mjs`) ; la
 * spec `fiche` en donne les règles (décision d'Igor du 2026-10-01).
 *
 * Chaque chose ouverte dit sa sorte :
 * - `pile` : ce qui s'ouvre par-dessus (la fiche, une feuille du bas, un panneau, un menu, le +,
 *   « Préparer ma journée »). Échap le ferme, et ce qui est dessous l'entend aussi : un menu et
 *   la fiche se ferment ensemble, comme avant.
 * - `garde` : une confirmation ou un choix ouvert au-dessus de la fiche (supprimer, déplacer).
 *   Échap le ferme, et ce qui est empilé dessous ne l'entend pas : la fiche reste.
 * - `a-cote` : ce qui est à côté, jamais couvert (l'Aide, Hiérarchiser). Échap le ferme quoi
 *   qu'il y ait par-dessus.
 * - `avant-tout` : la feuille des délais et le refus de boucle. Échap ne ferme qu'eux, avant
 *   même le champ qui a le curseur.
 *
 * Un champ qui garde Échap pour lui (le titre, une date, une heure, la recherche d'une
 * condition) l'arrête avant qu'il n'arrive ici : c'est le passage `bulle`. Seul `avant-tout`
 * passe avant lui : c'est le passage `capture`.
 */
export type SorteDEchap = 'pile' | 'garde' | 'a-cote' | 'avant-tout';

/**
 * Qui ferme à cet Échap, parmi les choses ouvertes (de la plus ancienne à la plus récente) :
 * leurs places dans la liste, de la plus récente à la plus ancienne.
 *
 * `capture` : le passage avant les champs. Seule la plus récente des `avant-tout` y répond, et
 * Échap s'arrête là. `bulle` : le passage après eux, s'ils l'ont laissé remonter. Ce qui est à
 * côté ferme toujours ; dans la pile, on ferme du haut vers le bas jusqu'à la première garde.
 */
export function aQuiVaLEchap(ouverts: readonly SorteDEchap[], passage: 'capture' | 'bulle'): number[] {
  const avantTout = ouverts.lastIndexOf('avant-tout');
  if (passage === 'capture') return avantTout === -1 ? [] : [avantTout];
  if (avantTout !== -1) return [];

  const fermes: number[] = [];
  let garde = false;
  for (let i = ouverts.length - 1; i >= 0; i -= 1) {
    const sorte = ouverts[i];
    if (sorte === 'a-cote') fermes.push(i);
    else if (!garde) {
      fermes.push(i);
      if (sorte === 'garde') garde = true;
    }
  }
  return fermes;
}
